<template>
  <v-select
      v-model="model"
      :options="options"
      :class="{'small': small}"
      label="name"
      :reduce="(currency) => currency.code"
      v-bind="selectProps"
  >
    <template #selected-option="option">
      {{option.name }} ({{option.symbol}})
    </template>
    <template #option="option">
      {{option.name }} ({{option.symbol}})
    </template>
  </v-select>
</template>

<script>
import { vue } from '@/main'

export default {
  name: 'CurrenciesSelectBox',
  props: {
    value: {
      required: true,
    },
    selectProps:{
      default: () => ({})
    },
    allowedCurrencies:{
      type:Array,
      default: () => null
    },
    small:{
      type:Boolean,
      default:false
    },
    readOnly:{
      type: Boolean,
      default: () => false
    },
  },
  computed:{
    options:{
      get(){
        let currencies = vue.$t('currencies');
        return Object.keys(currencies).map(key => ({
          name: currencies[key].name,
          code: key,
          symbol: currencies[key].symbol
        })).filter(c => this.allowedCurrencies == null || this.allowedCurrencies.includes(c.code));
      }
    },
    model:{
      get(){
        return this.value;
      },
      set(value){
        this.$emit('input',value);
      }
    }
  }
}
</script>

<style scoped>

</style>
